<template>
  <div style="display: contents;">
    <tr>
      <td colspan="3">
        <b-checkbox class="ml-3" v-model="checkboxModel" @change="$emit('change', $event)">
          <b><small>{{ paxLabel }}</small></b>
        </b-checkbox>
      </td>
      <td><small>{{ price.toFixed(2) }} {{ currency }}</small></td>
      <td></td>
    </tr>
  </div>
</template>

<script>
export default {
  props: {
    pax: {
      type: Object,
      required: true
    },
    roomIndex: {
      type: Number,
      required: true
    },
    paxIndex: {
      type: Number,
      required: true
    },
    currency: {
      type: String,
      required: true
    },
    paxPrices: {
      type: Array,
      required: true
    },
    checked: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      checkboxModel: this.checked
    }
  },
  computed: {
    paxLabel () {
      if (this.pax.fname && this.pax.lname) return this.pax.lname + ' ' + this.pax.fname
      return this.$gettext('Pax') + ' ' + (this.paxIndex + 1) + this.$gettext(' in room') + ' ' + (this.roomIndex + 1)
    },
    paxAge () {
      return this.pax.age
    },
    paxType () {
      return this.pax.type
    },
    price () {
      return this.paxPrices.find(el => (el.room_index === this.roomIndex) && (el.pax_index === this.paxIndex)).gross
    }
  },
  watch: {
    checked (value) {
      this.checkboxModel = value
    }
  }
}
</script>
